module.exports = __webpack_public_path__ + "img/IMG_9000_L.fca448e3.webp";